﻿$.fn.dxCtrlGridBcQR = function custom_dxCtrlGridBcQR(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridbcqr dx-ctrl");
        this.createInstance(new cdxCtrlGridBcQR(this, option));
    }
    return this;
}

window.cdxCtrlGridBcQR = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "gridbcqr"

    option.bddCtrl.mAddFunctionOnModifiedItemData(["bc_qr"], container,
        function (action, itemData) {
            if (typeof itemData != 'undefined') {
                dxGrid.mUpdateData(action, option.bddCtrl.table.mGetItemFromNom("bc_qr").id_table, itemData.id_bc_qr)
            } else {
                dxGrid.mUpdateData()
            }
        })

    var dxGrid = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid({
            bddCtrl: option.bddCtrl,
            noDataText: "Aucune question/réponse",
            typeData: "bc_qr",
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            lstTypeGrille: ["Détails"],
            fields: mGetLstField(),
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: true,
            getItemTemplateHeight: function () { return 80 },
            getAlignItem: function () { return "right" },
            itemTemplateGrille: function (container, dataTemplate, type) {
                $("<div style='margin:5px;text-align:left;'/>").appendTo(container).dxCtrlBcChkLienAppli({
                    bddCtrl: option.bddCtrl,
                    data: dataTemplate
                })
                $("<div style='margin:5px;'/>").appendTo(container).dxTextBox({
                    value: dataTemplate.question,
                    onValueChanged: function (e) {
                        var obj = option.bddCtrl.getObjet("bc_qr", dataTemplate.id)
                        obj.data.question = e.value
                        obj.mSave()
                    }
                })
                $("<div style='margin:5px;'/>").appendTo(container).dxTextArea({
                    value: dataTemplate.reponse,
                    height: 150,
                    onValueChanged: function (e) {
                        var obj = option.bddCtrl.getObjet("bc_qr", dataTemplate.id)
                        obj.data.reponse = e.value
                        obj.mSave()
                    }
                })
            },
            itemTemplateGrillePlus: function (container, dataTemplate, type) {
                var $S = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.dcr.toDateIlya(true) + "</span>").appendTo(container)
                $S.attr("title", "Créé le " + dataTemplate.dcr.toFrenchDateTime())
            },
            itemTemplateIco: function (container, dataTemplate) {
                $("<i class='fafa fafa-mia'></i>").appendTo(container)
            },
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
            },
        }).dxCtrlVirtualGrid("instance")
    }

    function mGetLstField() {
        var lst = []
        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date création",
            icon: "fas fa-clock-rotate-left",
            allowFilter: false,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            visible: true,
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            groupIndex: 0,
            sortOrder: "desc",
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Création: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
        }])
        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fafa fafa-mia",
                    icon2: "fas fa-certificate",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    txtTooltip: "Nouvel QR",
                    onClick: function (e) {
                        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                            fullscreen: false,
                            height: "auto",
                            width: 700,
                            title: "Q/R IA",
                            contentTemplate: function (contentElement) {
                                //var dxTagB = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTagBox({
                                //    label: "Code appli générale",
                                //    labelMode: 'floating',
                                //    dataSource: parametre.lst_appli_maitre,
                                //    value: [parametre.lst_appli_all.filter(function (o) { return o.code_appli == parametre.code_appli })[0].code_appli_general],
                                //    displayExpr: "code_appli",
                                //    valueExpr: "code_appli",
                                //    onValueChanged: function (e) {
                                //    }
                                //}).dxTagBox("instance")
                                var dxTxtQ = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTextBox({
                                    label: "Question",
                                    labelMode: 'floating',
                                    value: "",
                                    onValueChanged: function (e) {
                                    }
                                }).dxTextBox("instance")
                                var dxTxR = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTextArea({
                                    label: "Réponse",
                                    labelMode: 'floating',
                                    value: "",
                                    height: 150,
                                    onValueChanged: function (e) {
                                    }
                                }).dxTextArea("instance")
                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                    text: "ok",
                                    onClick: function (e) {
                                        var result = ""
                                        var data = option.bddCtrl.getObjet("bc_qr").mGetNewData()
                                        data.question = dxTxtQ.option("value")
                                        data.reponse = dxTxR.option("value")
                                        option.bddCtrl.getObjet(data).mSave(function () {
                                            dxGrid.mReloadData()
                                        })
                                        popup.hide()
                                    }
                                })
                            }
                        }).dxCtrlPopupBase("instance")
                        popup.show()
                    }
                }).dxCtrlButton("instance")
            }
        })

        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []

        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                icon: "fas fa-xmark",
                elementAttr: { class: "dx-button-grille-ligne" },
                focusStateEnabled: false,
                text: "Supprimer",
                hint: "Supprimer",
                onClick(e) {
                    e.event.stopPropagation();
                    option.bddCtrl.getObjet("bc_qr",dataGrid.id).mDelDataDefinitif()
                    dxGrid.mRemoveRow(dataGrid)
                }
            },
        })

        toolbar.option("items", items)
    }

    this.element = function () { return container }

    mConstruit();
}